export default __webpack_public_path__ + "static/media/kodachrome.934325d2.png";